import React from 'react';
import { Mail, FileText, TrendingUp } from 'lucide-react';
import { tools } from '../mock';

const iconMap = {
  Mail: Mail,
  FileText: FileText,
  TrendingUp: TrendingUp
};

const Tools = () => {
  return (
    <section id="tools" className="section-large">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our Tools
          </h2>
          <div className="w-20 h-1 bg-accent-teal mx-auto mb-6"></div>
          <p className="text-lg text-neutral-silver max-w-2xl mx-auto">
            Powerful tools to streamline your workflow and boost productivity
          </p>
        </div>

        {/* Tools Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {tools.map((tool) => {
            const IconComponent = iconMap[tool.icon];
            return (
              <div key={tool.id} className="tool-card">
                <div className="flex flex-col h-full">
                  <div className="flex items-center justify-center mb-6">
                    <div className="w-20 h-20 rounded-xl bg-accent-teal/10 flex items-center justify-center">
                      <IconComponent size={40} className="text-accent-teal" />
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-3">{tool.title}</h3>
                  <p className="text-neutral-silver leading-relaxed mb-6 flex-1">
                    {tool.description}
                  </p>
                  <a href="/tools" className="btn-secondary w-full text-center block">
                    Learn More
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Tools;
